"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalCalculatedPrice = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const Field_1 = require("../../../Form/Field");
const TotalCalculatedPrice = (props) => {
    const { value } = props;
    return (react_1.default.createElement("div", { className: `${__1.className}__total-calculated` },
        react_1.default.createElement(Field_1.FormField, { autoComplete: 'off', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:totalLabel', defaultMessage: 'Total calculated price' }), name: 'total-calculated', value: value, disabled: true, addon: 'CHF' })));
};
exports.TotalCalculatedPrice = TotalCalculatedPrice;
//# sourceMappingURL=TotalCalculatedPrice.js.map